import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBashgahProfileMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#26C6DA' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='m24.26 20.72-2.347-5.483c-.796-1.86-2.258-1.935-3.24-.165l-1.418 2.558c-.72 1.297-2.062 1.41-2.992.247l-.165-.21c-.968-1.215-2.333-1.065-3.03.323l-1.29 2.587c-.908 1.8.404 3.923 2.415 3.923h9.57c1.95 0 3.262-1.988 2.497-3.78M13.228 14a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5'
    />
  </svg>
);
export default SvgBashgahProfileMenu;
